var _path, _path2, _path3, _path4, _g, _circle, _path5, _path6, _path7, _circle2, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6216 34.7087C37.6216 34.7087 38.3497 35.7621 40.6689 37.2403C40.8425 37.3495 41.0245 37.4624 41.2162 37.5765C41.9444 38.0121 42.8 38.4757 43.8109 38.9563L44.0536 32.767C44.0536 32.767 47.209 33.0097 50.0002 31.7961C49.6786 31.6359 48.2927 30.8896 46.3 29.3447C46.1216 29.2075 45.9359 29.0619 45.749 28.9102C44.8679 28.2015 43.8861 27.3483 42.8364 26.335C41.2624 29.0049 37.6216 34.7087 37.6216 34.7087Z",
    fill: "url(#paint0_linear_27_838)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3786 34.3447C12.3786 34.3447 11.6505 35.3981 9.33131 36.8762C9.15777 36.9854 8.97573 37.0983 8.78398 37.2124C8.05583 37.6481 7.20631 38.1117 6.18932 38.5922L5.9466 32.4029C5.9466 32.4029 2.79126 32.6456 0 31.4321C0.321602 31.2719 1.70752 30.5255 3.70024 28.9806C3.87864 28.8435 4.06432 28.6978 4.25121 28.5461C5.13228 27.8374 6.11408 26.9842 7.16384 25.9709C8.73786 28.6408 12.3786 34.3447 12.3786 34.3447Z",
    fill: "url(#paint1_linear_27_838)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C35.858 0 44.6601 8.80215 44.6602 19.6602C44.6602 30.5182 35.858 39.3203 25 39.3203C14.142 39.3203 5.33984 30.5182 5.33984 19.6602C5.33986 8.80216 14.142 2.06175e-05 25 0ZM25 4.7334C16.756 4.7334 10.0733 11.4161 10.0732 19.6602C10.0732 27.9042 16.7559 34.5869 25 34.5869C33.2441 34.5869 39.9268 27.9042 39.9268 19.6602C39.9267 11.4161 33.244 4.7334 25 4.7334Z",
    fill: "#84391B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_838",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 40,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C35.858 0 44.6601 8.80215 44.6602 19.6602C44.6602 30.5182 35.858 39.3203 25 39.3203C14.142 39.3203 5.33984 30.5182 5.33984 19.6602C5.33986 8.80216 14.142 2.06175e-05 25 0ZM25 4.7334C16.756 4.7334 10.0733 11.4161 10.0732 19.6602C10.0732 27.9042 16.7559 34.5869 25 34.5869C33.2441 34.5869 39.9268 27.9042 39.9268 19.6602C39.9267 11.4161 33.244 4.7334 25 4.7334Z",
    fill: "#6C7E92"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_838)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27_838)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.1041,
    cy: 6.72962,
    rx: 4.49029,
    ry: 9.10194,
    transform: "rotate(42.5525 13.1041 6.72962)",
    fill: "#F9EEDE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_27_838)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8089,
    cy: 6.72964,
    rx: 4.49029,
    ry: 9.10194,
    transform: "rotate(150 37.8089 6.72964)",
    fill: "#DED6C3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_27_838)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.0676,
    cy: 33.0555,
    rx: 4.49029,
    ry: 9.10194,
    transform: "rotate(-135 36.0676 33.0555)",
    fill: "#E0C9B8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_27_838)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2518,
    cy: 31.3564,
    rx: 4.49029,
    ry: 9.10194,
    transform: "rotate(-45 13.2518 31.3564)",
    fill: "#E29F50"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9999,
    cy: 19.6602,
    r: 14.9272,
    fill: "url(#paint2_linear_27_838)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.64081C33.8472 3.64087 41.0195 10.8131 41.0195 19.6603C41.0195 28.5075 33.8472 35.6798 25 35.6799C16.1528 35.6799 8.98053 28.5076 8.98047 19.6603C8.98047 10.8131 16.1527 3.64081 25 3.64081ZM25 4.7326C16.7559 4.7326 10.0732 11.4163 10.0732 19.6603C10.0733 27.9043 16.756 34.5871 25 34.5871C33.244 34.5871 39.9267 27.9043 39.9268 19.6603C39.9268 11.4163 33.2441 4.73261 25 4.7326Z",
    fill: "url(#paint3_linear_27_838)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6604 13.5422L27.1895 16.649C27.2988 16.8796 27.5172 17.0373 27.7721 17.0738L31.2065 17.5713C31.8376 17.6684 32.0925 18.4451 31.6313 18.882L29.1434 21.2971C28.9614 21.4791 28.8764 21.7339 28.925 21.9767L29.5075 25.3869C29.6167 26.0179 28.9492 26.4912 28.391 26.2L25.3327 24.598C25.1022 24.4767 24.8352 24.4767 24.6167 24.598L21.5463 26.2121C20.9759 26.5034 20.3206 26.0301 20.4298 25.399L21.0124 21.9888C21.0609 21.7339 20.9759 21.4791 20.7939 21.3092L18.3182 18.8941C17.857 18.4451 18.1119 17.6684 18.7429 17.5835L22.1774 17.0859C22.4323 17.0495 22.6507 16.8917 22.7599 16.6611L24.2891 13.5543C24.556 12.9597 25.3813 12.9597 25.6604 13.5422Z",
    fill: "url(#paint4_linear_27_838)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1802 13.5004C24.4926 12.8133 25.448 12.8178 25.77 13.4896H25.769L27.2983 16.5951L27.2993 16.597C27.3792 16.7657 27.5295 16.8882 27.7104 16.9369L27.7896 16.9535L31.2241 17.4515H31.2251C31.9511 17.5633 32.2508 18.4587 31.7144 18.9681L31.7153 18.9691L29.228 21.3842C29.0924 21.5204 29.0225 21.7011 29.0337 21.8773L29.0444 21.9525V21.9564L29.6274 25.3666C29.7538 26.0986 28.9798 26.6447 28.3345 26.308V26.307L25.2769 24.7054H25.2759C25.0797 24.6023 24.8561 24.604 24.6753 24.7045L24.6733 24.7054L21.603 26.3197L21.6011 26.3207L21.6001 26.3197C20.9431 26.6543 20.1834 26.11 20.3101 25.3783L20.8931 21.9681V21.9662C20.9339 21.752 20.8627 21.5391 20.7114 21.3978L20.7095 21.3959L18.2339 18.9808C17.7018 18.4627 17.9933 17.563 18.7251 17.4633L22.1597 16.9662H22.1606C22.3762 16.9353 22.5587 16.8014 22.6499 16.6088L22.6509 16.6078L24.1802 13.5004Z",
    stroke: "url(#paint5_linear_27_838)",
    strokeWidth: 0.242718
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9999,
    cy: 19.6602,
    r: 14.6845,
    stroke: "url(#paint6_linear_27_838)",
    strokeWidth: 0.485437
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M40.4127 7.46359C39.4888 8.56922 38.6484 9.42294 37.6233 10.4155C37.5474 10.4909 37.4715 10.5663 37.3955 10.6416C37.3449 10.6919 37.3069 10.7296 37.2563 10.7798C37.0665 10.9557 36.8767 11.1442 36.6742 11.3201C36.5982 11.3829 36.535 11.4457 36.459 11.5211C36.4084 11.5588 36.3578 11.6091 36.3198 11.6468C36.2566 11.7096 36.1933 11.7598 36.13 11.8101C29.3974 17.7277 20.8425 21.3335 11.8067 21.9869C11.7181 21.9869 11.6421 21.9994 11.5536 21.9994C11.4903 21.9994 11.427 22.012 11.3637 22.012C11.2625 22.012 11.1739 22.0246 11.0727 22.0246C10.7436 22.0371 10.4146 22.0623 10.0856 22.0623C9.98431 22.0623 9.87041 22.0748 9.76917 22.0748C9.51607 22.0874 9.26296 22.0874 9.02251 22.0874C7.84558 22.0874 6.66864 22.0497 5.47905 21.9492C5.39046 21.2079 5.33984 20.4415 5.33984 19.6751C5.33984 8.80731 14.2112 0 25.1453 0C30.0681 0 34.4573 1.88928 37.9248 4.85437C38.8233 5.62077 39.6533 6.54643 40.4127 7.46359Z",
    fill: "url(#paint7_linear_27_838)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27_838",
    x: -1.04545,
    y: -7.79295,
    width: 28.2989,
    height: 29.0452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5801,
    result: "effect1_foregroundBlur_27_838"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_27_838",
    x: 24.6626,
    y: -8.6287,
    width: 26.2926,
    height: 30.7166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5801,
    result: "effect1_foregroundBlur_27_838"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_27_838",
    x: 21.729,
    y: 18.7171,
    width: 28.6768,
    height: 28.6768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5801,
    result: "effect1_foregroundBlur_27_838"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_27_838",
    x: -1.08646,
    y: 17.018,
    width: 28.6768,
    height: 28.6768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5801,
    result: "effect1_foregroundBlur_27_838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_838",
    x1: 47.2854,
    y1: 35.6575,
    x2: 39.915,
    y2: 30.4967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#E3029E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    stopColor: "#E527A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6172,
    stopColor: "#B90280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#730054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_838",
    x1: 4.06553,
    y1: 35.4976,
    x2: 9.58738,
    y2: 30.9466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#E3029E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5279,
    stopColor: "#E527A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6172,
    stopColor: "#B90280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#730054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_838",
    x1: 24.9999,
    y1: 4.73303,
    x2: 24.9999,
    y2: 34.5874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#403C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40303A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27_838",
    x1: 24.9999,
    y1: 3.64081,
    x2: 24.9999,
    y2: 35.6796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A763"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27_838",
    x1: 24.9687,
    y1: 13.2353,
    x2: 24.9687,
    y2: 24.7158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820804,
    stopColor: "#EDB966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2263,
    stopColor: "#DDDCD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3883,
    stopColor: "#E9B87D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5895,
    stopColor: "#853A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3954C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27_838",
    x1: 24.9747,
    y1: 13.1068,
    x2: 24.9747,
    y2: 26.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#863C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_27_838",
    x1: 24.9999,
    y1: 4.72908,
    x2: 24.9999,
    y2: 34.5834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_27_838",
    x1: 14.6072,
    y1: 3.03083,
    x2: 25.7134,
    y2: 18.5763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.79e80d61571de3e95a38f01b7ca9fdf6.svg";
export { ForwardRef as ReactComponent };